import Avatar from '@components/avatar';
import { RouterHyperlink, Table, Tag } from '@components/ui';
import { PersonFilledOutlined } from '@icon';
import getFullNameFromProfile from '@lib/utils/names/getFullNameFromProfile';
import React from 'react';
import { useIntl } from 'react-intl';
import { useHistory } from 'react-router-dom';
import type { ColumnWithLooseAccessor } from 'react-table';
import { IPrescriptionTableItem } from 'types/e-prescription.types';

type TColumn = ColumnWithLooseAccessor<IPrescriptionTableItem>;
type TParams = { onDetailClick: (item: IPrescriptionTableItem) => void };

export function useColumns(params: TParams) {
  const { onDetailClick } = params;

  const { formatMessage } = useIntl();
  const { push } = useHistory();

  return React.useMemo<TColumn[]>(
    () => [
      {
        id: 'avatar',
        Header: '',
        Cell: ({ row: { original } }) => (
          <Avatar imgUrl={original.client.profile.profileImage} size={34} />
        ),
      },
      {
        id: 'name',
        Header: formatMessage({ id: 'prescriptions.table.name' }),
        Cell: ({ row: { original } }) => (
          <RouterHyperlink to={`/life-id/${original.client.id}`} style={{ whiteSpace: 'nowrap' }}>
            {getFullNameFromProfile(original.client.profile)}
          </RouterHyperlink>
        ),
      },
      {
        id: 'email',
        Header: formatMessage({ id: 'prescriptions.table.email' }),
        Cell: ({ row: { original } }) => <>{original.client.email}</>,
      },
      {
        id: 'phoneNumber',
        Header: formatMessage({ id: 'prescriptions.table.phoneNumber' }),
        Cell: ({ row: { original } }) => <>{original.client.phoneNumber}</>,
      },
      {
        id: 'requestsCount',
        Header: formatMessage({ id: 'prescriptions.table.requestsCount' }),
        Cell: ({ row: { original } }) => <Tag>{original.count}</Tag>,
      },
      {
        id: 'actions',
        Header: '',
        Cell: ({ row: { original } }) => (
          <Table.Actions
            items={[
              {
                key: 'detail',
                label: formatMessage({ id: 'prescriptions.table.listAction' }),
                Icon: PersonFilledOutlined,
                onClick: () => {
                  onDetailClick(original);
                },
              },
              {
                key: 'life-id',
                label: formatMessage({ id: 'prescriptions.table.profileAction' }),
                Icon: PersonFilledOutlined,
                onClick: () => {
                  push(`/life-id/${original.client.id}`);
                },
              },
            ]}
          />
        ),
      },
    ],
    [formatMessage, onDetailClick],
  );
}
